import { useState, useEffect } from 'react';
import { Download } from 'lucide-react';
import { authService } from '../../services/api';
import { useNotification } from '../Notifications/NotificationContext';
import { useCopy } from '../../pages/utils/text/copy';
import ToggleCard from '../UI/Toggle/ToggleCard';

export default function ExportConfigModal({ open, bot, onClose }) {
    const { showError, showSuccess } = useNotification();
    const copy = useCopy();
    const [configKey, setConfigKey] = useState(bot?.config_key || '');
    const [configPublic, setConfigPublic] = useState(bot?.config_public || false);

    useEffect(() => {
        if (!open) return;
        let mounted = true;
        async function load() {
            if (!bot?.id) return;
            if (bot.config_key) {
                setConfigKey(bot.config_key);
                setConfigPublic(!!bot.config_public);
                return;
            }
            try {
                const res = await authService.bots.edit_bot(bot.id);
                if (res.data?.bot && mounted) {
                    setConfigKey(res.data.bot.config_key || '');
                    setConfigPublic(!!res.data.bot.config_public);
                }
            } catch (err) {
                // silent
            }
        }
        load();
        return () => { mounted = false; };
    }, [bot, open]);

    if (!open) return null;

    const handleConfigPublicChange = async (value) => {
        const prev = configPublic;
        setConfigPublic(!!value);
        try {
            await authService.bots.set_config_public(bot.id, !!value);
            showSuccess('Acesso público atualizado');
        } catch (err) {
            setConfigPublic(prev);
            showError(err?.response?.data?.error || err?.message || 'Erro ao atualizar Acesso Público');
        }
    };

    return (
        <div className="manage-bots-modal-overlay" onClick={onClose}>
            <div className="manage-bots-modal" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()}>
                <div className="manage-bots-modal-header">
                    <h3>
                        <Download size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '6px' }} />
                        Exportar Config
                    </h3>
                    <button type="button" className="manage-bots-close" onClick={onClose}>&times;</button>
                </div>

                <p className="text-sm text-white/40 mb-4">
                    Compartilhe essa chave para replicar a configuração de <strong className="text-white">{bot?.username || bot?.name}</strong> em outro bot.
                </p>

                <label className="text-xs font-bold text-white/40 uppercase tracking-wider mb-2 block">
                    Config Key
                </label>
                <button
                    type="button"
                    onClick={copy}
                    data-value={configKey}
                    disabled={!configKey}
                    className="input3 w-full px-3 py-2 text-md rounded hover:border-[#8b5cf6] text-left flex items-center justify-between gap-2"
                    title="Clique para copiar"
                >
                    <span className="truncate">{configKey || 'Carregando...'}</span>
                    <i className="fas fa-copy opacity-60" />
                </button>

                <div style={{ marginTop: 16 }}>
                    <ToggleCard
                        title="Acesso Público"
                        icon="fas fa-globe"
                        checked={configPublic}
                        onChange={handleConfigPublicChange}
                    />
                    <p className="text-xs text-white/40 mt-2">
                        Se ativado, qualquer pessoa com essa Config Key pode importar essa configuração para o próprio bot.
                    </p>
                </div>

                <div className="manage-bots-footer mt-2" style={{ marginTop: 16 }}>
                    <div />
                    <div className="manage-bots-footer-actions">
                        <button type="button" className="btn-secondary" onClick={onClose}>Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
